import type { HttpError } from "@repo/helpers";

import { useCallback } from "react";

// import { useUserContext } from "../contexts/userContext";

export function useApiWrapper() {
	//const { onAuthError } = useUserContext();

	const httpError = useCallback(
		(error: HttpError) => {
			switch (error.status) {
				case 401:
					alert("logged out");
					//onAuthError();
					break;
			}
		},
		[],
		//[onAuthError],
	);

	return useCallback(
		async function <TOut>(controllerCall: Promise<TOut>) {
			try {
				return await controllerCall;
			} catch (ex) {
				httpError(ex as HttpError);
				return null;
			}
		},
		[httpError],
	);
}
